/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Limit_2_TermInputs */

const en_svc_agents_limit_2_term = /** @type {(inputs: Svc_Agents_Limit_2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open-ended access`)
};

const lv_svc_agents_limit_2_term = /** @type {(inputs: Svc_Agents_Limit_2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nav neierobežotas piekļuves`)
};

/**
* | output |
* | --- |
* | "No open-ended access" |
*
* @param {Svc_Agents_Limit_2_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_limit_2_term = /** @type {((inputs?: Svc_Agents_Limit_2_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Limit_2_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_limit_2_term(inputs)
	return en_svc_agents_limit_2_term(inputs)
});